import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'
import { ElementsGroupToggleProps } from '../components/ElementsPanel/ElementsGroupToggle'

export const elementsGroupToggleStyles = makeStyles((theme: Theme) => ({
    elementsFilterWrapperSMMOM: {
        margin: theme.spacing(-0.5, 1, 0, 0.5),
        display: 'flex',
        alignItems: 'center',
        paddingBottom: theme.spacing(1.5),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(3.75),
        borderBottom: '1px solid #DDDDDD',
        '& .MuiMenu-paper': {
            left: 48,
        },
        paddingTop: (props: ElementsGroupToggleProps) =>
            props.isSearchBarHiddenInSMMOM ? theme.spacing(6.75) : 0,
    },
    activeFilterContainer: {
        background: '#185E8E',
        width: 26,
        height: 26,
        padding: theme.spacing(0.25),
        borderRadius: 4,
        '&:hover': {
            backgroundColor: '#185E8E',
        },
    },
    activeFilterIcon: {
        fill: '#ffffff',
    },
    leftPanelFilterIcon: {
        height: theme.spacing(2),
        width: theme.spacing(2),
    },
    filterIcon: {
        fill: '#185E8E',
    },
    divisionsAssemblyButton: {
        width: 87,
        height: 27,
        padding: theme.spacing(1.25, 1.5),
        borderRadius: 100,
        border: '1px solid #B5C7EA',
        fontSize: pxToRem(12),
        marginRight: theme.spacing(0.625),
    },
    activeGroupping: {
        backgroundColor: '#185E8E',
        border: '1px solid #185E8E',
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor: '#185E8E',
        },
    },
    elementsFilterContainer: {
        margin: theme.spacing(2, 1, 0, 0),
        display: 'flex',
        alignItems: 'center',
        paddingBottom: theme.spacing(1.5),
        borderBottom: '1px solid #DDDDDD',
        boxShadow: (props: ElementsGroupToggleProps) =>
            props.isBulkAddBarVisible
                ? '0 4px 4px -2px rgba(0, 0, 0, 0.25)'
                : 'none',
        '& .MuiMenu-paper': {
            left: 48,
        },
    },
    filterMenuText: {
        color: theme.palette.common.black,
        width: pxToRem(239),
    },
    elementGroupButtonContainerSMM: {
        display: 'none',
    },
    elementGroupButtonContainer: {
        paddingLeft: theme.spacing(2),
    },
    omVersionDropdownWrapper: {
        padding: theme.spacing(1.75, 1.25, 1.75, 2.75),
        borderBottom: '1px solid #DDDDDDCC',
    },
}))
